import { Component, OnInit, Output, EventEmitter, Inject, Optional } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

/** Optional caption overrides; legacy callers open the dialog with no data and get the "Comment" label. */
export interface SubmissionHistoryDialogData {
  title?: string;
  label?: string;
}

@Component({
    selector: 'submission-history-dialog',
    templateUrl: 'submission-history-dialog.html',
    styleUrls: ['submission-history-dialog.css'],
    standalone: false
})
export class SubmissionHistoryDialog implements OnInit{
  @Output() onConfirmed: EventEmitter<any> = new EventEmitter<any>();
  constructor(public dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) data: SubmissionHistoryDialogData | null) {
    this.title = data?.title ?? null;
    this.label = data?.label ?? 'Comment';
  }
  frmDialog: UntypedFormGroup;
  title: string | null;
  label: string;
  ngOnInit() {
    this.frmDialog = this.formBuilder.group({
      comment: [null, Validators.compose([
        Validators.required,
        Validators.minLength(20),
        Validators.maxLength(200)
        ])]
    });
  }

  Confirm() {
    if (!this.frmDialog.valid) {
      return false;
    }
    this.onConfirmed.emit(this.frmDialog.value.comment);
  }
}
